const DEFAULT_PREFIXES = ['', 'VITE_', 'REACT_APP_', 'NEXT_PUBLIC_'];

/**
 * Resolves a value from multiple possible environment sources (Node, Vite, CRA, Next, window)
 * using a list of supported prefixes.
 */
export function resolveEnvValue(key: string, prefixes: string[] = DEFAULT_PREFIXES): string | undefined {
    for (const prefix of prefixes) {
        const envKey = prefix ? `${prefix}${key}` : key;

        if (typeof process !== 'undefined' && process?.env?.[envKey]) {
            console.log(`process.env[${envKey}]`, process.env[envKey]);
            return process.env[envKey];
        }

        if (typeof import.meta !== 'undefined' && (import.meta as any)?.env?.[envKey]) {
            console.log(`import.meta.env[${envKey}]`, (import.meta as any).env[envKey]);
            return (import.meta as any).env[envKey];
        }

        if (typeof window !== 'undefined' && (window as any)?.__TAGADA_ENV__?.[envKey]) {
            console.log(`window.__TAGADA_ENV__[${envKey}]`, (window as any).__TAGADA_ENV__[envKey]);
            return (window as any).__TAGADA_ENV__[envKey];
        }
    }

    return undefined;
}

